
(function () {

  const STORAGE_KEY = '2lane:subscribe-popup';

  function readState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* private mode — treat as a first visit */ }
    return null;
  }

  function saveState(status, days) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        status: status,
        until: Date.now() + days * 24 * 60 * 60 * 1000
      }));
    } catch (e) { /* nothing to do */ }
  }

  function suppressed() {
    const state = readState();
    if (!state) return false;
    if (state.status === 'subscribed') return true;
    return Date.now() < state.until;
  }

  function init() {
    const popup = document.getElementById('subscribe-popup');
    if (!popup) return;

    const delay       = Number(popup.dataset.delay || 6) * 1000;
    const dismissDays = Number(popup.dataset.dismissDays || 14);
    const form        = popup.querySelector('[data-subscribe-form], .subscribe-popup__form');
    const email       = popup.querySelector('[data-subscribe-email], #subscribe-popup-email');
    const error       = popup.querySelector('[data-subscribe-error]');
    const success     = popup.querySelector('.subscribe-popup__success');
    const isStatic    = popup.dataset.staticPreview === 'true';

    let lastFocused = null;

    function isOpen() {
      return popup.classList.contains('is-open');
    }

    function showDone() {
      popup.classList.add('is-done');
      if (success && success.id) popup.setAttribute('aria-describedby', success.id);
    }

    function focusInside() {
      if (popup.classList.contains('is-done')) {
        const closeBtn = popup.querySelector('.subscribe-popup__close');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      } else if (email) {
        email.focus({ preventScroll: true });
      }
    }

    function open() {
      if (isOpen()) return;

      const busy = document.querySelector(
        '.cart-drawer.is-open, .qv.is-open, .garage.is-open, #mega-menu.is-open'
      );
      if (busy) {
        setTimeout(open, 8000);
        return;
      }

      lastFocused = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('has-overlay');
      focusInside();
    }

    function close(status) {
      if (!isOpen()) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.body.classList.remove('has-overlay');
      const done = popup.classList.contains('is-done');
      saveState(done ? 'subscribed' : (status || 'dismissed'), dismissDays);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    let sharedTrap = null;

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close('dismissed'); return; }
      if (e.key !== 'Tab') return;

      if (window.TwoLaneA11y) {
        if (!sharedTrap) sharedTrap = window.TwoLaneA11y.trap(popup, isOpen);
        sharedTrap(e);
        return;
      }

      const focusable = Array.prototype.filter.call(
        popup.querySelectorAll(
          'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
        ),
        function (el) { return el.getClientRects().length > 0; }
      );
      if (!focusable.length) return;
      const first  = focusable[0];
      const last   = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (!popup.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) { close('dismissed'); return; }
      if (e.target.closest('[data-subscribe-close]')) close('dismissed');
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!isStatic) {
          saveState('pending', 1 / 24);
          return;
        }

        e.preventDefault();
        const value = (email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          if (error) {
            error.hidden = false;
            error.textContent = 'Please enter a valid email address.';
          }
          email.focus();
          return;
        }
        if (error) error.hidden = true;
        showDone();
        saveState('subscribed', dismissDays);
        focusInside();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-subscribe-open]')) {
        e.preventDefault();
        open();
      }
    });

    if (popup.dataset.posted === 'true') {
      showDone();
      saveState('subscribed', dismissDays);
      open();
      return;
    }

    if (popup.dataset.error === 'true') {
      const formId = form ? form.getAttribute('id') : '';
      if (formId && window.location.hash === '#' + formId) {
        open();
        return;
      }
      if (error) error.hidden = true;
      if (email) {
        email.removeAttribute('aria-invalid');
        email.removeAttribute('aria-describedby');
      }
    }

    if (suppressed()) return;

    const path = window.location.pathname;
    if (/checkout|\/cart(\.html)?$/.test(path)) return;

    const scrollTarget = Math.min(95, Math.max(5,
      Number(popup.dataset.scrollPercent || 45)));

    let dwellDone = false;
    let fired     = false;
    let ticking   = false;

    function depthPercent() {
      const doc = document.documentElement;
      const max = doc.scrollHeight - window.innerHeight;
      if (max <= 8) return 100;
      return ((window.scrollY || doc.scrollTop || 0) / max) * 100;
    }

    function stopWatching() {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExitIntent);
    }

    function tryOpen() {
      if (fired || !dwellDone) return;
      fired = true;
      stopWatching();
      open();
    }

    function onScroll() {
      if (ticking || fired) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (depthPercent() >= scrollTarget) tryOpen();
      });
    }

    const finePointer = window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function onExitIntent(e) {
      if (!finePointer || fired) return;
      if (e.clientY > 0 || e.relatedTarget) return;
      tryOpen();
    }

    setTimeout(function () {
      dwellDone = true;
      if (depthPercent() >= scrollTarget) tryOpen();
    }, delay);

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExitIntent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
